const taskTemplates = require('../../task-templates');

const tasksData = [
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'research-paper-doll-equipment',
		text: `Sørg for at have det rigtige udstyr klar til produktionen. Vælg det rigtige udstyr. Tryk OK, når I er klar.`,
		popupText: `På HTX arbejder man også med udstyr i undervisningen. Det giver erfaring med værktøjer, som bruges i virkelige virksomheder.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'brains', title: 'Hjernen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'microscope', title: 'Mikroskop', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'lab-coat', title: 'Kittel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'safety-glasses', title: 'Sikkerhedsbriller', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'green-transition', title: 'Grøn omstilling i en tankeboble', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'plastic-gloves', title: 'Plastikhandsker', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'tie', title: 'Slips'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'keys', title: 'Nøgler'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'spray-bottle', title: 'Sprayflaske'
			}),
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'research-spot-errors-laboratory',
		layout: 'production-laboratory',
		text: `Orden er ekstremt vigtig i et laboratorium. Klik på de steder, hvor der er problemer. Tryk OK, når I mener, I har fundet dem alle.`,
		popupText: `Orden i laboratoriet er vigtig for sikkerhed og præcist arbejde. På HTX lærer man gode laboratorievaner fra starten.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'paper-on-floor'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'broken-lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'box-with-knife'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'clothes'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'sales-man'}),
		]
	}),
	/* case 2 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		image: 'htx-research-enzyme-production-1',
		title: 'Opgave 1',
		taskId: 'research-multiple-choice-ph-value',
		text: `Når produktionen starter i en ny tank, skal pH’en justeres. Enzymerne skal have et miljø på pH = 8, men ved start er pH = 3. Hvilke to ting kan der tilføres for at øge pH’en?`,
		hintText: `pH stiger, når man tilsætter noget, der er basisk, eller noget der fortynder syren.`,
		popupText: 'pH kan hæves ved at tilsætte en base eller ved fortynding med vand. På HTX arbejder man med kemi i praksis og justerer forhold, så processer fungerer optimalt.',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Syre', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Base',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Vand	',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Olie', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Mælk', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'research-input-answer-sugar-volumen',
		text: `Når pH’en er justeret til 8, blander man enzymerne med sukker (glukose) for at speede produktionen op. Optimalt skal der være <b>8 % glukose</b> i tanken. Volumen af tanken er <b>50.000 L</b>. Hvor mange liter glukose skal der tilsættes?`,
		hintText: `8 % betyder 8 ud af 100. Regn 8 % af 50.000 L.`,
		popupText: '8 % af 50.000 L er 4.000 L. På HTX bruger man matematik til at beregne mængder i kemiske processer.',
		answer: 4000,
		unit: 'L'
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'research-input-answer-sugar-mass',
		text: `Massefylden (densiteten) af glukosen er 1,56 kg/L. Hvor mange ton glukose skal der hældes i tanken?`,
		hintText: `Gang liter med kg pr. liter og omregn derefter til ton.`,
		popupText: 'Massefylde bruges til at omregne mellem volumen og masse. På HTX arbejder man med den slags beregninger i kemi og teknologi.',
		answer: 6.24,
		unit: 'ton'
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		image: 'htx-research-enzyme-production-2',
		title: 'Opgave 4',
		taskId: 'research-multiple-choice-average-temp',
		text: `Temperaturen i tanken skal holdes på 37 grader Celsius. Temperaturen måles hvert minut, så varmelegemet kan tændes og slukkes efter behov. Kig på grafen over målinger. Hvad var gns. temperaturen over de 60 minutter? `,
		hintText: `Det kan aflæses direkte på grafen ved at kigge på stregen for gennemsnitstemperaturen.`,
		popupText: 'Gennemsnit bruges til at få overblik over mange målinger. På HTX arbejder man med data og grafer for at styre processer i praksis.',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: '35', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: '36', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: '37', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: '38', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: '39', 
			}),
		],	
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 5,
	// 	title: 'Opgave 5',
	// 	taskId: 'research-multiple-choice-energy-source',
	// 	text: `Tanken kan opvarmes med enten gas eller el.
	// 	<br /><br />Der skal bruges 45 kWh til at varme indholdet i tanken op i to timer.<br />
	// 	Der skal bruges 10 m<sup>3</sup> naturgas til at varme indholdet op i to timer.
	// 	<br /><br />
	// 	1 kWh (kilowatttime) koster i gennemsnit 3,57 kr.<br />
	// 	1 m<sup>3</sup> naturgas koster i gennemsnit 27,15 kr. 
	// 	<br /><br />
	// 	Hvad vil være den billigste måde at opvarme tanken på?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Det er billigst med el', 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Det er billigst med gas', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Prisen er det samme for både el og gas', 
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 6,
	// 	taskId: 'research-order-process',
	// 	title: 'Opgave 6',
	// 	text: `Der skal laves en proces for, hvordan I introducerer nye kemikalier i produktionen. Sæt følgende procestrin i den rigtige rækkefølge.`,
	// 	image: 'process',
	// 	hintImage: 'production-process',
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'risc', 
	// 			text: `Risikovurdering`,
	// 			correctOrderNumbers: [1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'safety', 
	// 			text: `Sikkkerhedsforanstaltninger`,
	// 			correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'intro', 
	// 			text: `Oplæring og introduktion`,
	// 			correctOrderNumbers: [3]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'control', 
	// 			text: `Tilsyn og kontrol`,
	// 			correctOrderNumbers: [4]
	// 		})
	// 	]
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 3,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1',
	// 	taskId: 'research-multiple-choice-education',
	// 	text: `Hvis der skal flere robotter i produktionen, så kræver det efteruddannelse af medarbejderne. Hvad vil være det bedste område at uddanne dem indenfor?`,
	// 	image: 'production-technician',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Industrioperatør', 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Maskinmester', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Mekaniker', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Elektriker', 
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		image: 'htx-research-robot-1',
		title: 'Opgave 1',
		taskId: 'research-multiple-choice-investing',
		text: `Hvorfor er det en god ide at investere i robotteknologi?`,
		hintText: `Tænk på hvad robotter kan gøre bedre end mennesker i produktion, og hvad der kan gøre arbejdet hurtigere og mere stabilt.`,
		popupText: `Robotter kan øge tempo, præcision og stabilitet. På HTX arbejder man meget med teknologi, der kan gøre virksomheder mere effektive.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Spare penge på løn', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Tidsbesparelse i produktion', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Mere bæredygtigt', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Lettere at administrere end mennesker', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Kræver mindre uddannelse', 
			}),
		],
	}),

	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'research-multiple-choice-robot-colaboration',
		text: `En del af produktionen kræver robotter, der kan arbejde sammen med jeres medarbejdere. Hvilken type robot skal I vælge til opgaven?`,
		hintText: `Navnet på robotten afslører, at den kan samarbejde med mennesker.`,
		popupText: `Kollaborative robotter er designet til at arbejde sammen med mennesker. På HTX lærer man om robottyper og deres brug i moderne produktion.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Industrirobot',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Servicerobot',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Kollaborativ robot',
				isCorrect: true
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		image: 'htx-research-robot-2',
		title: 'Opgave 3',
		taskId: 'research-multiple-choice-robot-graph',
		text: `Kig på billedet. Hvor mange robotter var der pr. 50.000 ansatte i Danmark i 2019?`,
		hintText: `Grafen viser robotter pr. 10.000 ansatte. Spørgsmålet handler om 50.000, så du skal gange tallet med 5.`,
		popupText: `HTX arbejder man med at aflæse data og omsætte dem korrekt.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: '243',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: '486', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: '972', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: '1215',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: '1458', 
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 3,
	// 	title: 'Opgave 3',
	// 	taskId: 'research-multiple-choice-multiple-graphs',
	// 	text: `Kig på grafen, som viser de fire områders mulighed for automatisering. Hvilken afdeling har størst potentiale?`,
	// 	image: 'production-technicians-multiple-graphs',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Produktion',
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Montage og anlæg', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Lager og pakning', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Kontoropgaver og administrative processer',
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 1,
	// 	taskId: 'research-order-programming',
	// 	title: 'Opgave 1',
	// 	text: `I skal udvikle en ny softwarerobot, som skal aflaste personale og spare virksomheden penge. Vurdér, hvilke typer opgaver en softwarerobot vil være bedst til, og sortér dem i rækkefølge fra bedst til værst.`,
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'telephone', 
	// 			text: `Besvare telefonen`,
	// 			correctOrderNumbers: [1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'lights-off', 
	// 			text: `Sørge for at slukke lyset`,
	// 			correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'timeuse', 
	// 			text: `Automatisk registrering af timeforbrug`,
	// 			correctOrderNumbers: [3]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'economy', 
	// 			text: `Automatisk indtastning af kvitteringer`,
	// 			correctOrderNumbers: [4]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'social-activities', 
	// 			text: `Planlægning af sociale aktiviteter.`,
	// 			correctOrderNumbers: [5]
	// 		})
	// 	]
	// }),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		taskId: 'research-order-robot-tea',
		title: 'Opgave 1',
		text: 'Forestil jer, at I skal få en robot til at lave en kop te. Det lyder nemt, men robotten gør præcis det, I beder den om – hverken mere eller mindre. Sæt kommandoerne i den korrekte rækkefølge.',
		hintText: `Tænk på, hvad du helt præcist selv gør, trin for trin, hvis du laver en kop te.`,
		popupText: `Programmering handler om at tænke i meget præcise trin. På HTX lærer man at bryde handlinger ned, så computere og robotter kan udføre dem korrekt.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'lift-kettle', 
				text: `Løft elkoger`,
				correctOrderNumbers: [1, 9]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'move', 
				text: `Flyt elkoger hen under vandhanen`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'turn-on-water', 
				text: `Tænd vandet`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'turn-off-water', 
				text: `Sluk vandet når elkoger er fyldt`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'move-kettle-to-correct-place', 
				text: `Sæt elkoger på plads`,
				correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'turn-on-kettle', 
				text: `Tænd elkogeren`,
				correctOrderNumbers: [6]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'take-the', 
				text: `Tag fat i te-brev`,
				correctOrderNumbers: [7]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'place-the-into-kop', 
				text: `Put te-brev i kop`,
				correctOrderNumbers: [8]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'lift-kettle-again', 
				text: `Løft elkoger`,
				correctOrderNumbers: [9, 1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'pour-the-water-on-top', 
				text: `Hæld vand fra elkoger i kop`,
				correctOrderNumbers: [10]
			}),
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'research-multiple-choice-robot-typical-jobs',
		text: `Robotter er kun gode til nogle typer af opgaver. Hvilke tre opgaver har robotter typisk på en fabrik? Kun tre er rigtige.`,
		hintText: `Tænk på opgaver, der er ens hver gang og kan gentages igen og igen uden variation.`,
		popupText: `Robotter bruges især til gentagende og præcise opgaver som montage, pakning og inspektion. På HTX lærer man at vurdere, hvor teknologi giver mest værdi i produktionen.`,
		image: 'htx-research-robot-3',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Montage', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Skæring',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Opsamling og pakning',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Inspektion'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Syning',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'Varierede opgaver'
			})
		],
	}),
 	/* CASE 5 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 1,
		image: 'htx-research-accidents-1',
		taskId: 'research-multiple-choice-rd-stands-for',
		title: 'Opgave 1',
		text: `Først og fremmest: Hvad står R&D for?`,
		popupText: `R&D står for Research and Development. På HTX arbejder man med forskning og udvikling for at skabe nye løsninger og forbedre produkter.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 1, text: `Reformation and Delivery`}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 2, isCorrect: true,text: `Research and Development`}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 3, text: `Reformation and Development`}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {id: 4, text: `Research and Delivery`})
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 2,
		image: 'htx-research-accidents-2',
		taskId: 'research-multiple-choice-hole',
		title: 'Opgave 2',
		text: `Der er kun gået hul på én beholder. Hvad er den mest sandsynlige årsag?`,
		hintText: `Tænk på hvad der kan ske over tid, hvis et aktivt stof er opbevaret i den forkerte type plast.`,
		popupText: `Enzymer kan være så aktive, at de påvirker materialer omkring dem. På HTX arbejder man med kemi og materialer for at forstå, hvad der kan gå galt i praksis.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: `Laboranteleven tabte beholderen, inden den blev sat på plads`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: `Beholderen var i stykker, inden den blev påfyldt`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: `Der er sket en kemisk reaktion i beholderen`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: `Enzymet i beholderen har nedbrudt plasten`, 
				isCorrect: true
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 3,
	// 	title: 'Opgave 3',
	// 	taskId: 'research-multiple-choice-choose-analyses',
	// 	text: `I skal efterprøve, om enzymerne kan have lavet hul i beholderen. Der er kun væske nok tilbage til tre analyser. Snak sammen i teamet, og vælg de tre analyser, I tror, er bedst til opgaven.`,
	// 	popupText: 'I princippet kan alle undersøgelser bruges, men det vigtigste er at undersøge, om væsken nedbryder plastik.',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'pH-måling', 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Temperaturmåling',
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Hæld væsken over noget plastik og observer, hvad der sker',
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Lysfølsomhedstest'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'Ryst væsken og observer, hvad der sker'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6,
	// 			text: 'Mikroskopi'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7,
	// 			text: 'Test om væsken kan lede strøm'
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 1,
		title: 'Opgave 1',
		image: 'htx-research-enzyme-x-1',
		taskId: 'research-multiple-choice-patent',
		text: `Det er afgørende, at ingen ude fra får noget at vide om Enzym X. Det kan I sikre ved at tage patent. Gå på nettet og undersøg, hvad patent betyder. Vælg så det rigtige svar.`,
		hintText: `Søg på “hvad er et patent” og kig efter noget om rettigheder og beskyttelse af en opfindelse`,
		popupText: `Et patent beskytter en opfindelse mod at blive kopieret. På HTX arbejder man med innovation og forståelse af, hvordan idéer kan beskyttes i virkeligheden.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Patent betyder, at et produkt kan bruges, hvis bare man skriver, hvem der har opfundet det', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Patent er eneretten til erhvervsmæssig udnyttelse af en opfindelse',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Patent er en måde at dele sin opfindelse med andre virksomheder',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Patent betyder, at ingen må bruge opfindelsen, indtil patentet hæves'
			})
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 2,
	// 	title: 'Opgave 2',
	// 	taskId: 'research-multiple-choice-information-storage',
	// 	text: `I skal sikre, at jeres data om det nye enzym ikke bliver stjålet af konkurrenter. Hvad er de sikreste metoder til at opbevare data om Enzym X?`,
	// 	popupText: 'Det er vigtigt, at vi beskytter os mod udefrakommende hacking.',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Nedskrevet på et fysisk dokument lagt i et pengeskab', 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'På et USB-stik under direktørens hovedpude',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'I skyen',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'På R&D-afdelingens interne drev'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'Krypteret og gemt på et separat drev',
	// 			isCorrect: true
	// 		})
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 2,
		image: 'htx-research-enzyme-x-2',
		title: 'Opgave 2',
		taskId: 'research-multiple-choice-promote',
		text: `Hele verdenssamfundet kan få gavn af det nye enzym. For eksempel kan man potentielt nedbryde de kæmpestore plastøer, der ligger i verdenshavene. I har nu tre muligheder for at promovere og sælge Enzym X. Hvilken vil være bedst for firmaet?`,
		hintText: `Tænk på, hvordan virksomheden både kan hjælpe verden og samtidig overleve økonomisk.`,
		popupText: 'Virksomheder skal ofte balancere ansvar og forretning. På HTX arbejder man med at vurdere, hvordan innovation kan gavne samfundet og samtidig være bæredygtig for en virksomhed.',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Formlen stilles frit til rådighed, så alle kan producere Enzym X', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Vi giver en mængde gratis til verdenssamfundet. Resten sælges, så vi tjener penge',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Vi producerer og forhandler enzymet eksklusivt',
			}),
		],
	}),
	// CASE 7
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 1,
		taskId: 'research-order-development-phases',
		title: 'Opgave 1A',
		text: `En udviklingsproces forløber typisk i en række faser. Sæt faserne i den rigtige rækkefølge. Tryk OK, når I er klar.`,
		hintText: `Tænk på hvad man gør først, når man vil lave et nyt produkt – og hvad der naturligt kommer til sidst.`,
		poppupText: `Udvikling af lægemidler sker i faste faser fra idé til marked. På HTX arbejder man med at forstå processer og rækkefølger i teknologi og forskning.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'planning', 
				text: `Planlægning`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'research', 
				text: `Forskning`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'development', 
				text: `Udvikling`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'test', 
				text: `Test`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'marketing', 
				text: `Markedsføring`,
				correctOrderNumbers: [5]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 2,
		image: 'htx-research-new-development-1',
		title: 'Opgave 1B',
		lockedById: 'research-order-development-phases',
		taskId: 'research-multiple-choice-development-loops',
		text: `Når man udvikler nye produkter, er der især to af faserne, som gentages i loops. Hvilke to er det?`,
		hintText: `Tænk på de faser, hvor man ofte opdager fejl og justerer igen og igen.`,
		popupText: `På HTX arbejder man med processer, hvor man tester, justerer og tester igen.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Planlægning og forskning', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Forskning og udvikling',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Udvikling og test',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Test og markedsføring',
			}),
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 3,
		taskId: 'research-sort-know-your-chemistry',
		title: 'Opgave 2A',
		text: `Når man forsker, er det vigtigt at kende til kemi og grundstoffer. Sorter følgende grundstoffer i de rigtige kategorier. Tryk OK, når I er klar.`,
		hintText: `Prøv at google hvert grundstof og se, hvilken gruppe det hører til i det periodiske system.`,
		popupText: `På HTX arbejder man med det periodiske system for at forstå kemi i forskning og produktion.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'gas',
				title: `Ædelgasser`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'metal', 
				title: `Alkalimetaller`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'halo', 
				title: `Halogener`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Helium`,
				categoryIds: ['gas']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Radon`,
				categoryIds: ['gas']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Natrium`,
				categoryIds: ['metal']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Kalium`,
				categoryIds: ['metal']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				text: `Flour`,
				categoryIds: ['halo']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, 
				text: `Jod`,
				categoryIds: ['halo']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 4,
		// image: 'htx-research-new-development-2',
		image: 'htx-research-new-development-2b',
		title: 'Opgave 2B',
		lockedById: 'research-sort-know-your-chemistry',
		taskId: 'research-multiple-choice-call-communication',
		text: `En person fra kommunikationsafdelingen ringer til jer. Hun skal skrive en artikel og har brug for at vide, hvor mange naturlige grundstoffer, der er i det periodiske system. Hvad er det rigtige svar?`,
		hintText: `Søg på “hvor mange naturlige grundstoffer findes der” og kig efter tallet før de kunstigt fremstillede.`,
		popupText: `På HTX bruger man det periodiske system til at forstå, hvilke stoffer verden er bygget af, og hvordan de bruges i teknologi og kemi.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: '74', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: '84',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: '92',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: '104',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: '114',
			}),
		],
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 7,
		taskNumber: 5,
		title: 'Opgave 3',
		taskId: 'research-spot-errors-test-tubes',
		layout: 'research-test-tubes',
		text: `I forskningsafdelingen mangler de reagensglas. Hjælp dem med at finde så mange, I kan. Tryk på OK, når I er klar.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'test-tube1'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'test-tube2'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'test-tube3'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'test-tube4'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'test-tube5'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'test-tube6'}),
		]
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1',
	// 	taskId: 'research-multiple-choice-new-medicine',
	// 	text: `Udviklingen af den nye medicin er færdig, og I skal videre til næste fase. Men hvad er næste fase?`,
	// 	image: 'research-lab-people',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Planlægning', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Test',
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Forskning',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Salg',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'Markedsføring',
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 2,
	// 	title: 'Opgave 2',
	// 	taskId: 'research-spot-errors-clean-up',
	// 	layout: 'research-clean-up',
	// 	text: `Dagen er omme i forskningsafdelingen - det har været en god dag. Nu skal der ryddes op. Klik på alle de steder, hvor der er rod. Se, om I kan finde dem alle, og tryk så OK.`,
	// 	errors: [
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'mess1'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'mess2'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'mess3'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'mess4'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'mess5'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'mess6'}),
	// 	]
	// }),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'htx-research-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};